import '@mrhenry/wp--bugsnag-config';

import { MrCarousel, MrInputSink, MrMenu } from '@mrhenry/wp--mr-interactive';

import './modules/mr-blocked-content';
import './modules/mr-footer';
import './modules/mr-navigation-overlay';

customElements.define( 'mr-carousel', MrCarousel );
customElements.define( 'mr-input-sink', MrInputSink );
customElements.define( 'mr-menu', MrMenu );
